<template>

   <sdPageHeader>
      <template #title>
      <a-row :gutter="30">
        <a-col>
        <div class="product-single-description">
          <sdHeading class="product-single-title" as="h1" style="margin: 15px">
           No Show Review Report.
          </sdHeading>
          <span style="margin: 0px; font-size: 16px; font-weight: 400">
          </span>
        </div>
        </a-col>
        </a-row>
        <ProductCard
    class="list-view"
    :style="{ width: '100%', marginBottom: '10px' }"
    >
    <div class="product-list" style="padding: 10px;background-color:#ffffff;">
    
        <!--<BasicFormWrapper>-->
            <a-form
              name="contact"
              :rules="rules"
              :model="formState"
              @submit="handleOk"
              :layout="formState.layout"
            >
            <a-row :gutter="20">
            <!--<a-col :md="5">
              <a-form-item name="center">
                <a-select
                  v-model:value="formState.center"
                  style="width: 100%"
                  showSearch
                >
                <a-select-option
                  v-for="item in branchData"
                  v-bind:key="item.branch_code"
                  :value="item.branch_code"
                >
                  {{ item.branch_code }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="3">
            <a-form-item name="user">
            <a-select
                v-model:value="formState.user"
                style="width: 100%"
                @change="onChange"
                showSearch
                >
                <a-select-option
                value="E2E"
                >E2E
                </a-select-option>
                <a-select-option
                value="Accounting"
                >Accounting
                </a-select-option>
            </a-select>    
            </a-form-item>
             </a-col>-->
            <a-col :md="6">
              <a-form-item name="organization" label="Domain">
                <a-select
                  v-model:value="formState.organization"
                  style="width: 100%"
                  showSearch
                >
                <a-select-option
                  v-for="item in orgData"
                  v-bind:key="item.organization"
                  :value="item.organization"
                >
                  {{ item.organization }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="5">
            <a-form-item name="condition">
             <a-range-picker
                  style="padding-top: 10px !important"
                  @change="DateSelect"
                  :defaultValue="selectrange"
                />   
            </a-form-item>
            </a-col>
            
            <a-col :md="5">
            <a-form-item>
              <a-button 
                htmlType="submit"
                size="default"
                type="primary"
                key="submit"
                class="btn-add_new"
                style="margin-top: -1.5px !important;"
              >
               <span style="display: inline-flex !important;
              align-items: center !important;">
              <sdFeatherIcons type="arrow-down-circle" size="14" />  &nbsp; 
              Get Report</span>
              </a-button>
             </a-form-item>
              </a-col>
             
              </a-row>
            </a-form>

          <!--</BasicFormWrapper>-->
          
          </div>
          </ProductCard>
      </template>
     
    </sdPageHeader>
     
  <Main>
    <sdCards headless>
    
    <sdHeading class="product-single-title" as="h3" style="margin: 10px">
    List of Leads
    </sdHeading>
      <template v-if="selectedoption == 'Active'">
      <a-row :gutter="15" style="">
      <a-col :md="24">
        <div
          class="
            product-single-title
            page-header-actions
            product-single-description
          "
          style="margin-left: 70% !important"
        >     
            <a-col :md="16">
              <a-form-item>
                <a-select
                v-model:value="formState.reportType"
                style="width:100%"
              >
                <a-select-option value="standard">
                  Standard
                </a-select-option>
                <a-select-option value="detailed">
                  Detailed
                </a-select-option>
              </a-select>
              </a-form-item>
            </a-col>
              
            <a-col :md="8">
              <a-form-item>
                <a-button class="btn-signin" size="small" @click="exportToCSV()">
                  <span
                    style="
                      display: block !important;
                      align-items: center !important;
                    "
                  >
                    <sdFeatherIcons type="download" size="14" /> &nbsp;
                    Export</span
                  >
                </a-button>
              </a-form-item>
            </a-col>

        </div>
        </a-col> 
        </a-row>
        <a-row :gutter="15">
          <a-col :md="24">
             <TableWrapper class="table-responsive">
              <a-table
                class="ant-table-striped"
                thead-class="greenColor"
                :data-source="TableData"
                :rowSelection="rowSelection"
                :columns="DynamicColumns"
                :row-class-name="
                  (_record, index) => (index % 2 === 1 ? 'table-striped' : null)
                "
                :pagination="{
                    defaultPageSize: 10,
                    total: TableData.length,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`,
                }"
              >
              </a-table>
            </TableWrapper>
          </a-col>
        </a-row>
      </template>
      
    </sdCards>
  </Main>
</template> 
<script>
import { ContactPageheaderStyle, Action, UserTableStyleWrapper ,ProjectSorting,TopToolBox,} from '../../style';
import { defineComponent, h } from 'vue';
import { Main, CardToolbox, TableWrapper,BasicFormWrapper } from '../../../styled';
import { dispatch, useStore } from 'vuex';
import { ProductCard } from "./style";
import { defineAsyncComponent, computed, reactive, ref, onMounted, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { message, Notification, } from 'ant-design-vue'; 
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
export default defineComponent({
  name: 'NoShowReport',
  components: {
    Main,
    CardToolbox,
    BasicFormWrapper,
    UserTableStyleWrapper,
    TableWrapper,ProjectSorting,TopToolBox,ProductCard,
  },
  setup() {
    var loading = ref(true);
    var branchData = ref();
    var userData = ref();
    var orgData = ref();
    var checkselected = ref(false);
    var selectcount = ref(null);
    var selectedid = ref(null);
    var selectedoption = ref('Active');
    var selectrange = ref(null);
    const { dispatch, state } = useStore();
    const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT; 
    state.StatusData.data = [];
    onMounted(() => {
    getdata();
    getdata1();
    }); 
    const formState = reactive({
      center: "Select Branch",
      user: "Select Team",
      organization: "Corient-UK",
      reportType: "standard",
      });
    const rules = {
      center: [
        {
          required: true,
          message: "Please select criteria first",
          trigger: "blur",
        },
      ],
      };
    const DateSelect = (date, dateString) => {
      selectrange.value = dateString;
    };
    const handleOk = (values) => {
      statusData();
    };
    const openurl = (id) => {
      let url = '/index/';
      window.open(
          url + id +'/0',
          "_self",
      ); 
      
    };
    const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
        selectedRowKeys.value = selectedRowKeys;
        selectedRows.value = selectedRows; 
        if (selectedRowKeys.value.length == 0) {
          checkselected.value = false;
        } else {
          checkselected.value = true;
          selectedid = selectedRowKeys.value;
          selectcount.value = selectedRowKeys.value.length + ' Rows Selected';
        }
      },
     
    };
  const getdata = () => {
      loading.value = true;
      dispatch("getAssignFieldsData").then(
        (response) => {
          if (response.status == 200) {
            branchData.value = response.data[0];
            userData.value = response.data[1];
            loading.value = false;
          } else {
            loading.value = false;
            //onCancel();
          }
        },
        (error) => {
          console.log(error);
          loading.value = false;
         }
      );
      
    };
    const getdata1 = () => {
      loading.value = true;
      dispatch("manualFieldsData").then(
        (response) => {
          if (response.status == 200) {
            orgData.value = response.data[8];
            loading.value = false;
          } else {
            loading.value = false;
            //onCancel();
          }
        },
        (error) => {
          console.log(error);
          loading.value = false;
        }
      );
      
    };
    const statusData = () => {
     var range = selectrange.value.toString().split(",");
     let startdate = new Date(range[0]);
      let enddate = new Date(range[1]);
      startdate = startdate.toLocaleDateString("en-CA");
      enddate = enddate.toLocaleDateString("en-CA");
        let api_data = [];
        api_data['center'] = formState.center;
        api_data['selected_user'] = formState.user;
        api_data['organization'] = formState.organization;
        api_data['startdate'] = startdate;
        api_data['enddate'] = enddate;
        
        loading.value = true;
        dispatch("NoShowLeads",api_data).then(
            (response) => {
                if (response.status == 200) {
                    state.StatusData.data = response.data;
                    Notification["success"]({
                    message: "Succsess!",
                    description: "Leads Loaded.",
                    });
                    loading.value = false;
                } else {
                    loading.value = false;
                    //onCancel();
                }
            },
            (error) => {
                loading.value = false;
                state.StatusData.data = [];
                Notification["error"]({
                message: "Error!",
                description: "Error Loading Leads",
            });
          } 
          
        );
    }
    const StandardColumns = [
      {
        title: "Date",
        dataIndex: "formatted_date",
        key: "formatted_date",
        width: "120px",
        sorter: (a, b) => new Date(a.formatted_date) - new Date(b.formatted_date),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Opportunity Owner",
        dataIndex: "user_id",
        key: "user_id",
        sorter: (a, b) => a.user_id.length - b.user_id.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Company",
        dataIndex: "Company",
        key: "Company",
        width: "200px",
        sorter: (a, b) => a.Company.length - b.Company.length,
        sortDirections: ["descend", "ascend"],
        customRender: ({ text }) => {
          return h(
            'div',
            {
              style: {
                whiteSpace: 'pre-wrap',
                maxHeight: '150px',
                overflowY: 'auto',
                overflowX: 'hidden',
                wordBreak: 'break-word',
              }
            },
            text
          );
        },
      },
      {
        title: "Interest",
        dataIndex: "interest",
        key: "interest",
        sorter: (a, b) => a.interest.length - b.interest.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Opp Amt",
        dataIndex: "opportunity_amt",
        key: "opportunity_amt",
        sorter: (a, b) => a.opportunity_amt.length - b.opportunity_amt.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Data Source",
        dataIndex: "Lead_Source",
        key: "Lead_Source",
        sorter: (a, b) => a.Lead_Source.length - b.Lead_Source.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Lead Creator",
        dataIndex: "qualified_by",
        key: "qualified_by",
        sorter: (a, b) => a.qualified_by.length - b.qualified_by.length,
        sortDirections: ["descend", "ascend"],
      },
    ];
    const DetailedColumns = [
      {
        title: "Date",
        dataIndex: "formatted_date",
        key: "formatted_date",
        width: "120px",
        sorter: (a, b) => new Date(a.formatted_date) - new Date(b.formatted_date),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Opportunity Owners",
        dataIndex: "user_id",
        key: "user_id",
        sorter: (a, b) => a.user_id.length - b.user_id.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Company",
        dataIndex: "Company",
        key: "Company",
        width: "200px",
        sorter: (a, b) => a.Company.length - b.Company.length,
        sortDirections: ["descend", "ascend"],
        customRender: ({ text }) => {
          return h(
            'div',
            {
              style: {
                whiteSpace: 'pre-wrap',
                maxHeight: '150px',
                overflowY: 'auto',
                overflowX: 'hidden',
                wordBreak: 'break-word',
              }
            },
            text
          );
        },
      },
      {
        title: "Name",
        dataIndex: "Name",
        key: "Name",
        sorter: (a, b) => a.Name.length - b.Name.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Phone",
        dataIndex: "phone",
        key: "phone",
        sorter: (a, b) => a.phone.length - b.phone.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Website",
        dataIndex: "Website",
        key: "Website",
        sorter: (a, b) => a.Website.length - b.v.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Email",
        dataIndex: "Email_Address",
        key: "Email_Address",
        sorter: (a, b) => a.Email_Address.length - b.Email_Address.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Interest",
        dataIndex: "interest",
        key: "interest",
        sorter: (a, b) => a.interest.length - b.interest.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Opportunity",
        dataIndex: "opportunity_amt",
        key: "opportunity_amt",
        sorter: (a, b) => a.opportunity_amt.length - b.opportunity_amt.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Data Source",
        dataIndex: "Lead_Source",
        key: "Lead_Source",
        sorter: (a, b) => a.Lead_Source.length - b.Lead_Source.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Lead Source",
        dataIndex: "lead_type",
        key: "lead_type",
        sorter: (a, b) => a.lead_type.length - b.lead_type.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Lead Creator",
        dataIndex: "qualified_by",
        key: "qualified_by",
        sorter: (a, b) => a.qualified_by.length - b.qualified_by.length,
        sortDirections: ["descend", "ascend"],
      },
    ];
    const DynamicColumns = computed(() => {
      return formState.reportType === "standard"
        ? StandardColumns
        : DetailedColumns;
    });   
     let TableData = computed(() =>
        state.StatusData.data.map((unreconcile) => {
          const {
            id,
            ref_id,
            Company,
            Name,
            phone,
            Website,
            Email_Address,
            current_status,
            user_id,
            user,
            Assign_To,
            Action,
            turn_over,
            Probability,
            Job_Title,
            Industry,
            Lead_Source,
            Country,
            total_employees,
            opportunity_amt,
            next_followup,
            sla,
            live,
            datetime,
            Text,
            dead_month,
            lead_type,
            month,
            formatted_date,
            interest,
            qualified_by,
            } = unreconcile;
          return {
            key: id,
            id: id,
            ref_id:ref_id,
            month:month,
            formatted_date:formatted_date,
            Company: Company,
            Name: Name,
            phone:phone,
            Website:Website,
            Email_Address:Email_Address,
            current_status: current_status,
            user_id: user_id,
            user: user,
            Assign_To: Assign_To,
            Action: Action,
            turn_over: turn_over,
            Probability: Probability,
            Job_Title: Job_Title,
            Industry: Industry,
            Lead_Source: Lead_Source,
            Country: Country,
            total_employees: total_employees,
            opportunity_amt: opportunity_amt,
            next_followup: next_followup,
            sla: sla,
            live: live,
            datetime: datetime,
            Text: Text,
            dead_month: dead_month,
            lead_type:lead_type,
            interest: interest,
            qualified_by:qualified_by,
            } 
            
        }
        )
    );

    const exportToCSV = () => {
      let inputData = [];

      // STANDARD REPORT
      if (formState.reportType === "standard") {

        inputData = state.StatusData.data.map((item) => ({
            ID: item.id,
            Date: item.formatted_date,
            "Opportunity Owner": item.user_id,
            Company: item.Company,
            Interest: item.interest,
            "Opportunity Amt": item.opportunity_amt,
            "Data Source": item.Lead_Source,
            "Lead Creator": item.qualified_by,
        }));

      }

      // DETAILED REPORT
      else {

        inputData = state.StatusData.data.map((item) => ({
          ID: item.id,
            Date: item.formatted_date,
            "Opportunity Owner": item.user_id,
            Company: item.Company,
            Name:item.Name,
            phone:item.phone,
            Website:item.Website,
            Email_Address:item.Email_Address,
            Interest: item.interest,
            "Opportunity Amt": item.opportunity_amt,
            "Data Source": item.Lead_Source,
            "Lead Creator": item.qualified_by,
        }));

      }

      if (!inputData.length) {
        Notification["warning"]({
          message: "No Data",
          description: "No records available for export.",
        });
        return;
      }

      const range = selectrange.value
        ? selectrange.value.toString().split(",")
        : ["", ""];

      const fileName =
        formState.reportType === "standard"
          ? `No Show Standard Report ${range[0]}-${range[1]}`
          : `No Show Detailed Report ${range[0]}-${range[1]}`;
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";

      const ws = XLSX.utils.json_to_sheet(inputData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);

      Notification["success"]({
        message: "Success!",
        description: "Downloaded.",
      });
    };
    return {
      loading,
      DynamicColumns,
      TableData,
      branchData,
      userData,
      rowSelection,
      selectcount,
      checkselected,
      selectedoption,
      handleOk,
      exportToCSV,
      formState,
      selectrange,
      DateSelect,
      rules,
      openurl,
      orgData,
     };
  },
});
</script> 
<style scoped>
.ant-table-striped :deep(.table-striped) td th{
  background-color: #447316;
}
th {
  //background-color: #93BF34 !important;
}
.ant-btn-primary {
  background-color: #5C69B3 !important;
  border: 1px solid #5C69B3 !important;
}
.supp-head div{
        width: 250px;
}

.ant-col .ant-select {
  margin-top: 4px;
}
.ant-col button{
  margin-top: 5px;
}
table thead tr th:last-child {
    text-align: left !important;
}
.ant-page-header-heading {
  display: block !important;

}
</style>